import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, Navigate, Link } from "react-router-dom";
import {
  faCheckCircle,
  // faChevronRight,
  //   faEnvelope,
  //   faPhone
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faXTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import "./Thankyou.css";

const Thankyou = () => {
  const location = useLocation();

  if (!location.state?.fromForm) {
    return <Navigate to="/404/" replace />;
  }

  return (
    <div>
      <div className="thank-you-container">
        <div className="thank-you-content">
          <FontAwesomeIcon icon={faCheckCircle} className="thank-you-icon" />
          <h1>Thank you!</h1>
          <p>
            Thank you for reaching out to Apollo Financial Services. We'll be in
            touch shortly. Please keep an eye on your email and mobile phone for
            our update. We are open Monday to Friday from 9:00 a.m. to 1:00 p.m.
            and from 2:00 p.m. to 5:00 p.m., excluding bank holidays. If you
            have any questions, please don't hesitate to contact us by phone at
            01 689 5066 or by email at info@apollofinancial.ie.You can also
            visit our <Link to="/resources/content-hub/" className="thankyou-hub-link">Content Hub</Link> for valuable insights and information.
          </p>
          <div className="action-boxes">
            <div className="action-box">
              <h2>Connect With Us</h2>
              <div className="social-icons">
                <a
                  href="https://www.facebook.com/ApolloFinancialServicesLtd"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a
                  href="https://x.com/ApolloFServices"
                  aria-label="Twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faXTwitter} />
                </a>
                <a
                  href="https://ie.linkedin.com/company/apollo-financial-services-limited"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a
                  href="https://www.instagram.com/apollofinancialservices/"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
              {/* <div className="contact-methods">
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <span>info@example.com</span>
              </div>
              <div className="contact-item">
                <FontAwesomeIcon icon={faPhone} />
                <span>(123) 456-7890</span>
              </div>
            </div> */}
            </div>

            {/* <div className="action-box">
            <h2>Back to Website</h2>
            <a href="/" className="visit-button">
              Visit Website{" "}
              <FontAwesomeIcon icon={faChevronRight} className="button-icon" />
            </a>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Thankyou;
